export default __webpack_public_path__ + "static/media/gift-card.c4688f94.svg";